import api, { withLoading } from '@/api/api';

const resource = `v1/ict/etapas`;
const LOADING_KEY = 'ict-etapas';

export default {
    getAll(empresaId, params = {}) {
        const { query } = params;
        return withLoading(LOADING_KEY, () =>
            api.get(`${resource}/${empresaId}${query ? `?${query}` : ""}`).then(res => res.data)
        );
    },
    getOne(empresaId, etapaId) {
        return withLoading(LOADING_KEY, () =>
            api.get(`${resource}/${empresaId}/${etapaId}`).then(res => res.data)
        );
    },
    create(empresaId, data) {
        return withLoading(LOADING_KEY, () =>
            api.post(`${resource}/${empresaId}`, data).then(res => res.data)
        );
    },
    update(empresaId, etapaId, data) {
        return withLoading(LOADING_KEY, () =>
            api.post(`${resource}/${empresaId}/${etapaId}`, data).then(res => res.data)
        );
    },
    delete(empresaId, etapaId) {
        return withLoading(LOADING_KEY, () =>
            api.delete(`${resource}/${empresaId}/${etapaId}`).then(res => res.data)
        );
    }
}
